<template>
  <v-container class="cmp-distribution-accounts-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedAccountsDetails &&
              selectedAccountsDetails.account &&
              selectedAccountsDetails.account.account_name
            "
          >
            <span
              v-if="selectedAccountsDetails && selectedAccountsDetails.account"
              >{{
                selectedAccountsDetails.account.account_name || "Account Name"
              }}</span
            >
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div
                v-if="
                  selectedAccountsDetails && selectedAccountsDetails.account
                "
              >
                {{
                  selectedAccountsDetails.account.account_name || "Account Name"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <glayout
        :tabs="accountSidewindowTabs"
        :loading="selectedAccountsDetails && selectedAccountsDetails.loading"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox :title="`${$t('account')} ${$t('tab_title_main_setup')}`">
                <AccountSetup
                  :statusTV="statusTV"
                  @changed="onAccountChanged"
                  :selectedAccountsDetails="selectedAccountsDetails"
                />
              </gbox>
              <gbox
                v-if="selectedAccountsDetails"
                :title="$t('notes')"
                bc="var(--bc-note)"
              >
                <DBoxTextarea
                  :id="'notes'"
                  :value="selectedAccountsDetails.account.notes"
                  @blur="
                    (e) =>
                      onAccountChanged({ name: 'notes', value: e.target.value })
                  "
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedAccountsDetails &&
                      selectedAccountsDetails.files &&
                      selectedAccountsDetails.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedAccountsDetails.files"
                  :externalId="`${selectedAccountsDetails.account.account_id}`"
                  :externalTable="'account'"
                />
              </gbox>
            </gcol>

            <gcol>
              <gbox
                v-if="selectedAccountsDetails"
                :title="$t('invoice_contact')"
              >
                <InvoiceContact
                  :invoiceContact="
                    selectedAccountsDetails.invoice_contact || {}
                  "
                  :contactConfig="{
                    external_id: selectedAccountsDetails.account.account_id,
                    external_table: 'l_accounts',
                    external_name: 'contact_id_invoice',
                    config_type: 'DistributionAccountInvoiceConfig',
                    key: 'account_id',
                  }"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedAccountsDetails &&
                      selectedAccountsDetails.contact_relations &&
                      selectedAccountsDetails.contact_relations.length
                  )
                "
                :title="$t('related_contacts')"
              >
                <RealtedContacts
                  :contact_relations="selectedAccountsDetails.contact_relations"
                  :external_id="`${selectedAccountsDetails.account.account_id}`"
                  :external_table="'account'"
                  @delete="onRelatedContactDelete"
                  @changed="onRelatedContactChange"
                  @contact_selected="onRelatedContactSelected"
                />
              </gbox>
              <gbox
                v-if="selectedAccountsDetails"
                :title="$t('delivery_address')"
              >
                <InvoiceContact
                  :invoiceContact="
                    selectedAccountsDetails.delivery_contact || {}
                  "
                  :contactConfig="{
                    external_id: selectedAccountsDetails.account.account_id,
                    external_table: 'l_accounts',
                    external_name: 'contact_id_delivery',
                    config_type: 'DistributionAccountDeliveryConfig',
                    key: 'account_id',
                  }"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="setup">
          <grow>
            <gcol>
              <gbox :title="`${$t('additional_setup')}`">
                <AdditionalSetup
                  @changed="onAccountChanged"
                  :selectedAccountsDetails="selectedAccountsDetails"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedAccountsDetails &&
                      selectedAccountsDetails.account_pricecodes &&
                      selectedAccountsDetails.account_pricecodes.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: 32,
                    max: 10,
                    min: 0,
                  })
                "
                :title="`${$dft.capHead($t('discount'))}`"
              >
                <DiscountSetup
                  @change="onDiscountChange"
                  @delete="onDiscountDelete"
                  @insert="onDiscountInsert"
                  :selectedAccountsDetails="selectedAccountsDetails"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedAccountsDetails &&
                      selectedAccountsDetails.relations &&
                      selectedAccountsDetails.relations.length,
                    offset: NTOffsets.WithHeader,
                    rowHeight: 32,
                    max: 10,
                    min: 1,
                  })
                "
                :title="`${$t('manual_matches')}`"
              >
                <ManualMatches
                  @delete="onDeleteRelation"
                  :selectedAccountsDetails="selectedAccountsDetails"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="`${$t('additional_setup')}`">
                <AdditionalSetup2
                  @changed="onAccountChanged"
                  :selectedAccountsDetails="selectedAccountsDetails"
                />
              </gbox>
              <gbox bc="var(--bc-note)" :title="`${$t('shipping_info')}`">
                <DBoxTextarea
                  :id="'shipping_info'"
                  :value="selectedAccountsDetails.account.shipping_info"
                  @blur="
                    (e) =>
                      onAccountChanged({
                        name: 'shipping_info',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
              <gbox bc="var(--bc-note)" :title="`${$t('deal_memo_internal')}`">
                <DBoxTextarea
                  :id="'deal_memo'"
                  :value="selectedAccountsDetails.account.deal_memo"
                  @blur="
                    (e) =>
                      onAccountChanged({
                        name: 'deal_memo',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="catalogue">
          <!-- `${$t('add')} ${$t('entity')}` -->
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedAccountsDetails &&
                      selectedAccountsDetails.label_accounts &&
                      selectedAccountsDetails.label_accounts.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('labels')"
              >
                <CatalogueLabels
                  @changed="onAccountItemChanged"
                  @add_click="onAddClick"
                  :selectedAccountsDetails="selectedAccountsDetails"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedAccountsDetails &&
                      selectedAccountsDetails.product_accounts &&
                      selectedAccountsDetails.product_accounts.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$dft.capHead($t('catalogue'))"
              >
                <CatalogueList
                  @changed="onAccountItemChanged"
                  @add_click="onAddClick"
                  :selectedAccountsDetails="selectedAccountsDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="all_orders" :title="$t('tab_title_orders')">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedAccountsDetails &&
                      selectedAccountsDetails.orders &&
                      selectedAccountsDetails.orders.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('tab_title_orders')"
              >
                <OrderList
                  @add_click="onAddClick"
                  :selectedAccountsDetails="selectedAccountsDetails"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedAccountsDetails &&
                      selectedAccountsDetails.backorders &&
                      selectedAccountsDetails.backorders.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('backorders_string')"
              >
                <BackOrders
                  @changed="onAccountItemChanged"
                  :selectedAccountsDetails="selectedAccountsDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="current_statements">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedAccountsDetails &&
                      selectedAccountsDetails.current_statements &&
                      selectedAccountsDetails.current_statements.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: 32,
                    max: 10,
                   // min: 1,
                  })
                "
                :title="$t('current_statements')"
              >
                <CurrentStatements
                  :isEnabled="isEnabled"
                  :selectedAccountsDetails="selectedAccountsDetails"
                  @delete="onDeleteCurrentStatement"
                  @setStatementsIvoice="onSetStatementsIvoice"
                  @setAccounOnMultipleInvoice="setAccounOnMultipleInvoice"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="import_setup">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedAccountsDetails &&
                      selectedAccountsDetails.statement_settings &&
                      selectedAccountsDetails.statement_settings.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: 32,
                    max: 10,
                   // min: 1,
                  })
                "
                :title="$t('import_setup')"
              >
                <ImportSetup
                  :selectedAccountsDetails="selectedAccountsDetails"
                  @update="onImportSetupUpdate"
                  @delete="onDeleteImportSetup"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="statements_history">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedAccountsDetails &&
                      selectedAccountsDetails.statements &&
                      selectedAccountsDetails.statements.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: 32,
                    max: 10,
                    min: 1,
                  })
                "
                :title="$t('statements_history')"
              >
                <StatementHistory
                  :selectedAccountsDetails="selectedAccountsDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="invoice_costs" :title="$t('tab_title_invoice_costs')">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedAccountsDetails &&
                      selectedAccountsDetails.invoices &&
                      selectedAccountsDetails.invoices.length,
                    offset: NTOffsets.WithHeader,
                    min: 1,
                  })
                "
                :title="$t('invoice')"
              >
                <InvoiceList
                  :selectedAccountsDetails="selectedAccountsDetails"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedAccountsDetails &&
                      selectedAccountsDetails.costs &&
                      selectedAccountsDetails.costs.length,
                    offset: NTOffsets.WithHeader,
                    min: 1,
                  })
                "
                :title="$dft.capHead($t('main_costs'))"
              >
                <CostList :selectedAccountsDetails="selectedAccountsDetails" />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <ModalContainer :modalKey="'addOrderForm'" :width="'small'">
      <AddOrderForm
        @cancelled="onDialogCancelled"
        @added="onOrderAdded"
        :selectedAccountsDetails="selectedAccountsDetails"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addCatalogueForm'" :width="'small2'">
      <addCatalogueForm
        @added="onCatalogueAdded"
        @cancelled="onDialogCancelled"
        :selectedAccountsDetails="selectedAccountsDetails"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addLabelForm'" :width="'small2'">
      <addLabelForm
        @added="onLabelAdded"
        @cancelled="onDialogCancelled"
        :selectedAccountsDetails="selectedAccountsDetails"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'salesDateSmallerModal'" :width="'small2'">
      <Modal
        v-if="crp"
        :id="'cmp-sales_date_smaller_modal'"
        @cancelled="onCancel"
      >
        <template slot="body">
          There are already royalty statements which are including the periods
          of the selected statements.
          {{ crp.royalty_date }}
          <TextField
            class="m1"
            :id="'royalty_date1'"
            required
            v-bind="textFieldConfig"
            :value="crp.royalty_date1"
            :type="'date'"
            :placeholder="$t('royalty_date')"
            :showValidationIcons="true"
            :immediateValidation="true"
            @valuechanged="onRoyalty_date1Change"
          />
        </template>
        <template slot="options">
          <button class="dt-button s6" @click.stop="onCancel">
            {{ $t("cancel") }}
          </button>
          <button class="dt-button v1 s6" @click.stop="onCRPProceed">
            {{ $t("proceed") }}
          </button>
        </template>
      </Modal>
    </ModalContainer>
  </v-container>
</template>

<script>
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { distributionAccountActions } from "../../store/accounts/actions";
import { createTV, createTVI } from "../../../../models/text-value.model";
import { distributionAccountGetters } from "../../store/accounts/getters";
import { distributionAccountListLDTRoutes } from "../../router/routes";
import { contactListLDTRoutes } from "../../../contacts/router/routes";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { checkTabListPermission } from "../../../../router/guard";
import BoxWidget from "@plugins/box-widget/box-widget";
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import {
  createModalMixin,
  openModalRoute,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";

import { AccountService } from "../../services/account.service";
export const moduleRoute = "distribution";
export const submenuRoute = "accounts";

import RealtedContacts from "@/dt-plugins/add-contact-relation/related-contacts";
import InvoiceContact from "@/dt-plugins/dbox-invoice-contact/dbox-invoice-contact.vue";
import ModalContainer from "@dtplugins/modal/modal-container";
import StatementHistory from "./statement-history.vue";
import OrderList from "./order-list.vue";
import InvoiceList from "./invoice-list.vue";
import BackOrders from "./backorders.vue";
import CatalogueLabels from "./catalogue-labels.vue";
import CatalogueList from "./catalogue-list.vue";
import CostList from "./cost-list.vue";
import AddOrderForm from "./add-order.vue";
import addCatalogueForm from "./add-catalogue.vue";
import addLabelForm from "./add-label.vue";
import AccountSetup from "./account-setup.vue";
import CurrentStatements from "./current-statements.vue";
import ImportSetup from "./import-setup.vue";
import AdditionalSetup from "./additional-setup.vue";
import AdditionalSetup2 from "./additional-setup2.vue";
import ManualMatches from "./manual-match-setup.vue";
import DiscountSetup from "./discount-setup.vue";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import { distributionOrderListLDTRoutes } from "../../router/routes";
import {
  executeFunctionExpInt,
  executeFunctionExpIntP,
  wait,
} from "../../../../utility";
import { distributionStatementsGetters } from "../../store/statement/getters";
import { distributionStatementsActions } from "../../store/statement/actions";
import { okMessage } from "@/dt-plugins/confirmation/confirmation-common";
import { defaultTextFieldConfig } from "../../../../plugins/text-field";
export default {
  components: {
    ModalContainer,
    BoxWidget,
    DBoxTextarea,
    DBoxFiles,
    StatementHistory,
    OrderList,
    InvoiceList,
    BackOrders,
    CostList,
    AddOrderForm,
    CatalogueLabels,
    CatalogueList,
    addCatalogueForm,
    addLabelForm,
    AccountSetup,
    RealtedContacts,
    InvoiceContact,
    CurrentStatements,
    ImportSetup,
    AdditionalSetup,
    AdditionalSetup2,
    ManualMatches,
    DiscountSetup,
  },
  data() {
    return {
      isEnabled: true,

      crp: null,
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },
    };
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("addOrderForm"),
    createModalMixin("addCatalogueForm"),
    createModalMixin("addLabelForm"),
    createModalMixin("salesDateSmallerModal"),
  ],
  computed: {
    ...mapGetterObject(storeNS, distributionAccountGetters),
    ...mapGetterObject(storeNS, distributionStatementsGetters),

    accountSidewindowTabs: function () {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("overview"),
        },
        {
          route: "setup",
          value: this.$t("setup"),
        },
        {
          route: "catalogue",
          value: this.$t("catalogue"),
        },
        {
          route: "all_orders",
          value: this.$t("tab_title_orders"),
        },
        {
          route: "current_statements",
          value: this.$t("current_statements"),
        },
        {
          route: "import_setup",
          value: this.$t("import_setup"),
        },
        {
          route: "statements_history",
          value: this.$t("statements_history"),
        },
        {
          route: "invoice_costs",
          value: this.$t("tab_title_invoice_costs"),
        },
      ]);
    },
    // TABULATION REFACTORING

    account_id: function () {
      return this.$route.params.account_id;
    },

    selectedAccountsDetails: function () {
      const selectedAccount =
        this.distributionAccountDetails?.[this.account_id] || {};
      console.log("selected Account", selectedAccount);
      const account = selectedAccount?.account || {};
      console.log("Account", account);

      const order_types = selectedAccount?.order_types || [];

      const contra_accounts = selectedAccount?.contra_accounts || [];

      const shipping_types = selectedAccount?.shipping_types || [];

      const price_lists = selectedAccount?.price_lists || [];

      return {
        ...selectedAccount,
        account,
        order_types,
        contra_accounts,
        shipping_types,
        price_lists,
      };
    },
    statusTV: function () {
      return (
        this.accountDistributionData?.label_statuses?.map((e) => {
          return {
            text: e.label_status_name,
            value: e.label_status_id,
            color: `#${e.label_status_colour}`,
          };
        }) || []
      );
    },
  },
  async mounted() {},
  methods: {
    ...mapActionObject(storeNS, distributionAccountActions),
    ...mapActionObject(storeNS, distributionStatementsActions),

    onRelatedContactSelected: function () {
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: contact.contact_id,
          tab: "overview",
        },
      });
    },

    onAccountItemChanged: function (payload) {
      const res = AccountService.modify({
        ...payload,
      });
    },

    onAccountChanged: function (payload) {
      console.log("Changed value ", payload);
      this[ActionTypes.DistributionAccountDetails.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedAccountsDetails,
      });
    },

    onSelectedAccount: function (selectedAccountId) {
      this.$router.push({
        name: distributionAccountListLDTRoutes.names.tab,
        params: {
          account_id: selectedAccountId,
          tab: "overview",
        },
      });
    },
    onNotesBlur: function (event) {
      this.onAccountChanged({
        name: "notes",
        value: event.target.value,
      });
    },
    // MARK: Methods

    onAdded: function (payload) {
      this.onDialogCancelled();
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onAddClick: function (e) {
      openModalRoute(this, e, {
        mode: "add",
      });
    },
    onEditClick: function (e) {
      openModalRoute(this, "edit_payment_form", {
        mode: "add",
      });
      this.selectedPayment = {
        ...e,
      };
    },
    onCatalogueAdded: function (e) {
      this[ActionTypes.DistributionCatalogueAccount.SET.ALL]({
        account_id: this.selectedAccountsDetails?.account?.account_id,
        product_accounts: e || [],
      });
      this.onDialogCancelled();
    },
    onLabelAdded: function (e) {
      this[ActionTypes.DistributionCatalogueLabels.SET.ALL]({
        account_id: this.selectedAccountsDetails?.account?.account_id,
        label_accounts: e || [],
      });
      this.onDialogCancelled();
    },
    onOrderAdded: function (e) {
      const orders = [e, ...this.selectedAccountsDetails.orders];
      this[ActionTypes.DistributionOrderList.SET.ALL]({
        account_id: this.selectedAccountsDetails?.account?.account_id,
        orders: orders || [],
      });

      this.$router.push({
        name: distributionOrderListLDTRoutes.names.tab,
        params: {
          order_id: e.order_id,
          tab: "overview",
        },
      });
      this.onDialogCancelled();
    },
    onContactAdded: function (e) {
      this[ActionTypes.RoyaltyAccountsMainContacts.SET.ALL]({
        supplier_id: this.selectedAccountsDetails?.account?.supplier_id,
        contact: e || {},
      });
      this.onDialogCancelled();
    },
    onContractAdded: function (e) {
      this[ActionTypes.RoyaltyAccountsContracts.SET.ALL]({
        supplier_id: this.selectedAccountsDetails?.account?.supplier_id,
        contracts: e || [],
      });
      this.onDialogCancelled();
    },
    onStatementAdded: function (e) {},
    onEditPaymentAdded: function (e) {
      const payments = this.selectedAccountsDetails.payments.map((p) => {
        if (p.payment_id === e.payment_id) {
          p = {
            ...e,
          };
        }
        return p;
      });

      this[ActionTypes.RoyaltyAccountsPayments.SET.ALL]({
        supplier_id: this.selectedAccountsDetails?.account?.supplier_id,
        payments: payments || [],
      });
      this.onDialogCancelled();
    },

    onSelectedContract: function (selectedContractId) {
      this.$router.push({
        name: royaltyContractsListLDTRoutes.names.tab,
        params: {
          contract_id: selectedContractId,
          tab: "overview",
        },
      });
    },
    onContactSelected: function (selectedContactId) {
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: selectedContactId,
          tab: "overview",
        },
      });
    },

    //overview
    onRelatedContactChange: function ({ name, value, item }) {
      this[ActionTypes.DistributionAccountRelatedContacts.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedAccountsDetails: this.selectedAccountsDetails,
      });
    },

    onRelatedContactDelete: function (contact) {
      this[ActionTypes.DistributionAccountRelatedContacts.DELETE.SINGLE]({
        contact,
        selectedAccountsDetails: this.selectedAccountsDetails,
      });
    },

    onDeleteCurrentStatement: async function (item) {
      const confirmationResult = await ConfirmationService.createP({
        body: this.$t("delete_cur_sttmnt_msg"),
        results: [
          createConfirmResult({
            value: "cancel",
            text: "Cancel",
          }),
          createConfirmResult({
            value: "ok",
            text: "OK",
            classes: ["v1"],
          }),
        ],
      });

      if (confirmationResult == "ok") {
        this[ActionTypes.DistributionAccountCurrentStatements.DELETE.SINGLE]({
          item,
          account_id: this.selectedAccountsDetails?.account?.account_id,
        });
      }
    },
    setAccounOnMultipleInvoice: async function (payload) {
      console.log(":::::::::::", "MULTIPLE",JSON.stringify(Array.from(payload)));
      this.crp = null;
      const crp = await AccountService.check_royalty_period(
        Array.from(payload)
      );

      this.crp = {
        ...this.crp,
        ...crp,
      };

      if (this.crp.sales_date_smaller) {
        openModalRoute2(this, "salesDateSmallerModal", {
          mode: "multiple",
          statement_ids: Array.from(payload),
        });
        return;
      }

      this.onSetMultipleStatementsInvoice(payload);
    },

    async onSetMultipleStatementsInvoice(payload) {
      this.isEnabled = false;
      await this[ ActionTypes.DISTRIBUTION_ACCOUNT_SET_MULTIPLE_STATEMENTS_INVOICE]({
        ids:Array.from(payload),
        account_id: this.selectedAccountsDetails?.account?.account_id,
      });
      this.isEnabled = true;
      await okMessage("You will be notified once the processing is complete");
    },

    onSetStatementsIvoice: async function (payload) {
      this.crp = null;
      const crp = await AccountService.check_royalty_period(
        Array.from(payload)
      );

      this.crp = {
        ...this.crp,
        ...crp,
      };

      console.log(":::::::::::crp",this.crp,JSON.stringify(Array.from(payload)))

      if (this.crp.sales_date_smaller) {
        openModalRoute2(this, "salesDateSmallerModal", {
          mode: "single",
          statement_ids: Array.from(payload),
        });
        return;
      }

      this.setStatementInvoiceToAPI(payload);
    },

    async setStatementInvoiceToAPI(payload) {
      const royalty_date1 = this.crp?.royalty_date1;
      console.log('payloadpayloadpayloadpayloadpayloadpayloadpayloadpayload2',payload)
      const inv = await this[ActionTypes.DISTRIBUTION_ACCOUNT_SET_STATEMENTS_INVOICE]({
        ids:  Array.from(payload),
        account_id: this.selectedAccountsDetails?.account?.account_id,
        royalty_date1,
      });

      const statement_ids = Array.from(payload);
      // console.log({'accunt-sidewindow.vue:796 statement_ids' : statement_ids});

      const statementNavTabs = Object.entries(
        this.distributionStatementDetails || {}
      );

      const matchedNavTabs = statement_ids.map((sid) => statementNavTabs.find(([did, sd]) => sid == did)).filter((e) => e);
      // console.log({'account-sidewindow.vue:804 matchedNavTabs' : matchedNavTabs});

      // for (const [statement_id, statement_details] of matchedNavTabs) {
      //   let fetchedStatementDetails = false;
      //   executeFunctionExpInt(() => {
      //     this[ActionTypes.DistributionStatementsDetails.FETCH.SINGLE]({
      //       statement: {
      //         statement_id,
      //       },
      //       reload: true,
      //     }).then(sd => {
      //       fetchedStatementDetails = sd;
      //     });
      //   }, (count) => {
      //     console.log(`Checking Statement Details ${fetchedStatementDetails?.statement?.statement_id} Invoice ID: ${fetchedStatementDetails?.statement?.invoice_id} Count: ${count}`);
      //     return fetchedStatementDetails?.statement?.invoice_id != null ||
      //       count > 8
      //     }, 1, 1000);
      // }

      await Promise.all([
        ...matchedNavTabs.map(([statement_id, statement_details]) => {
          let fetchedStatementDetails = false;
          return executeFunctionExpIntP(
            () => {
              this[ActionTypes.DistributionStatementsDetails.FETCH.SINGLE]({ statement: { statement_id },reload: true }).then((sd) => {
                fetchedStatementDetails = sd;
              });
            },
            (count) => {
              return (
                fetchedStatementDetails?.statement?.invoice_id != null ||
                count > 8
              );
            },
            1,
            1000
          );
        }),
        this.refresh(),
      ]);

      // await this.refresh();

      //invoiceListLDTRoutes
      if (process === "next") {
        await okMessage("You will be notified once the processing is complete");
      } else {
        this.$router.push({
          name: invoiceListLDTRoutes.names.tab,
          params: {
            invoice_id: inv.invoice.invoice_id,
            tab: "overview",
          },
        });
      }
    },

    onCRPProceed() {
      // console.log("Proceeding", this.crp);
      const mode = this.$route.query?.mode;
      const statement_ids = this.$route.query?.statement_ids;
      const royalty_date1 = this.crp.royalty_date1;

      console.log("::::::::statement_ids",statement_ids)
      this.onDialogCancelled();

      // console.log(
      //   `Proceeding with ${royalty_date1} with Mode: ${mode} 
      //   with statement_ids: ${statement_ids}`
      // );

      if (mode === "single") {
        this.setStatementInvoiceToAPI(statement_ids);
      } else if (mode === "multiple") {
        this.onSetMultipleStatementsInvoice(statement_ids);
      }
    },
    onCancel() {
      this.onDialogCancelled();
    },
    onRoyalty_date1Change(name, value) {
      this.crp = {
        ...this.crp,
        royalty_date1: value,
      };
    },

    async refresh() {
      await this[ActionTypes.DistributionAccountDetails.FETCH.SINGLE]({
        account: {
          account_id: this.selectedAccountsDetails?.account?.account_id,
        },
        reload: true,
      });
    },

    onImportSetupUpdate: function (payload) {
      console.log(":::::::::::::::::::::::::::::::::::::::::::::");
      this[ActionTypes.DistributionAccountImportSetup.UPDATE.SINGLE](payload);
    },

    onDeleteImportSetup: function (payload) {
      this[ActionTypes.DistributionAccountImportSetup.DELETE.SINGLE]({
        ...payload,
      });
    },
    onDiscountChange: function (payload) {
      this[ActionTypes.DistributionAccountDiscount.UPDATE.SINGLE]({
        ...payload,
        account_id: this.account_id,
      });
      console.log(payload);
    },
    onDiscountDelete: function (payload) {
      this[ActionTypes.DistributionAccountDiscount.DELETE.SINGLE]({
        item: payload,
        account_id: this.account_id,
      });
      console.log(payload);
    },
    onDiscountInsert: function () {
      this[ActionTypes.DistributionAccountDiscount.INSERT.SINGLE]({
        account_id: this.account_id,
      });
    },

    onDeleteRelation: function (item) {
      this[ActionTypes.DistributionAccountManualMatch.DELETE.SINGLE]({
        account_id: this.account_id,
        item,
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-accounts-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 149px);
  }
}
</style>
